import axios from 'axios'

export default {
  namespaced: true,
  state: {
    quizzes: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    quizzes(state, value) {
      state.quizzes = value
    }
  },
  actions: {
    fetchLessonQuizzes({commit, state}, {lessonId}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        // axios.get(`/lesson/${lessonId}/quiz`)
        axios.get(`/quiz/${lessonId}`)
          .then((response) => {
            commit('quizzes', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    fetchQuiz({commit, state}, id) {
      return axios.get(`/quiz/${id}`)
        .then(({data}) => {
          return Promise.resolve(data)
        })

    }
  },
  getters: {
    quizzes: state => state.quizzes,
    loading: state => state.loading
  }
}
